import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {
  AirportContractListAttachmentRecord,
  AirportContractListContactsGetRecord,
  AirportContractListService,
} from 'src/app/shared';
import { FuelSupplierGetRecord, FuelSupplierService } from 'src/app/shared';
import { AirportContractListGetRecord } from 'src/app/shared';
import { FuelPriceIndexTypeService, FuelPriceIndexType } from 'src/app/shared';
import { DictionaryFuelPriceIndexService } from 'src/app/shared';
import { DictionaryFuelPriceIndexRecord } from 'src/app/shared';
import { AirportContractListAdditionalFeeGetRecord } from 'src/app/shared';
import {
  DictionaryCurrencyService,
  DictionaryUnitConverterService,
  DictionarySapSymbolsDataService,
  DictionaryPapIndexDataService,
  DictionaryPapIndexEntity
} from 'src/app/shared';
import { AirportContractListAttachmentService } from 'src/app/shared/services/airport-contract-list-attachment.service';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  standalone: false,
  selector: 'app-contract-details-dialog',
  templateUrl: './contract-details-dialog.component.html',
  styleUrls: ['./contract-details-dialog.component.scss'],
})
export class ContractDetailsDialogComponent implements OnInit {
  fuelSupplierContacts: FuelSupplierGetRecord[] = [];
  accountManagerContacts: FuelSupplierGetRecord[] = [];
  itpAgentContacts: AirportContractListContactsGetRecord[] = [];
  fuelPriceIndexName: string = 'N/A';
  papIndexName: string = 'N/A';
  papIndexData: DictionaryPapIndexEntity | null = null;
  fuelPriceIndexTypeName: string = 'N/A';
  fuelPriceIndexSymbol: string = '';
  fuelPriceIndexData: any = null;
  additionalFees: AirportContractListAdditionalFeeGetRecord[] = [];
  fuelPriceIndexMap: Map<number, any> = new Map();
  additionalFeeCurrencyMap: Map<number, string> = new Map();
  additionalFeeUnitMap: Map<number, string> = new Map();
  safIndexName: string = '';
  safIndexValue: number = 0;
  safIndexValueCurrency: string = '';
  safIndexValueUnit: string = '';
  contractedAmountUnit: string = '';
  contractedValueCurrency: string = '';
  paymentTerms: string = '';
  indexValueCurrency: string = '';
  indexValueUnit: string = '';
  differentialCurrency: string = '';
  differentialUnit: string = '';
  hookUpFeeCurrency: string = '';
  hookUpFeeUnit: string = '';
  lessThan1000LtrCurrency: string = '';
  lessThan1000LtrUnit: string = '';
  noFuelCurrency: string = '';
  noFuelUnit: string = '';
  outOfHoursCurrency: string = '';
  outOfHoursUnit: string = '';
  sapSymbolValue: string = '';
  attachments: AirportContractListAttachmentRecord[] = [];
  downloadingFile: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ContractDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AirportContractListGetRecord,
    private fuelSupplierService: FuelSupplierService,
    private airportContractListService: AirportContractListService,
    private fuelPriceIndexTypeService: FuelPriceIndexTypeService,
    private dictionaryFuelPriceIndexService: DictionaryFuelPriceIndexService,
    private dictionaryPapIndexService: DictionaryPapIndexDataService,
    private dictionaryCurrencyService: DictionaryCurrencyService,
    private dictionaryUnitConverterService: DictionaryUnitConverterService,
    private dictionarySapSymbolsService: DictionarySapSymbolsDataService,
    private airportContractListAttachmentService: AirportContractListAttachmentService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.data.fuelSupplierId) {
      this.loadFuelSupplierContacts(this.data.fuelSupplierId);
    }
    if (this.data.id) {
      this.loadITPAgentContacts(this.data.id);
      this.loadAdditionalFees(this.data.id);
      this.getAttachments(this.data.id);
    }
    if (this.data.fuelPriceIndexTypeId) {
      this.loadFuelPriceIndexType(this.data.fuelPriceIndexTypeId);
    }
    if (this.data.fuelPriceIndexId) {
      this.loadFuelPriceIndex(this.data.fuelPriceIndexId);
    }
    if (this.data.papIndexId) {
      this.loadPapIndex(this.data.papIndexId);
    }
    if (this.data.contractedAmountUnitConverterId) {
      this.loadContractedAmountUnit(this.data.contractedAmountUnitConverterId);
    }
    if (this.data.contractedValueCurrencyId) {
      this.loadContractedValueCurrency(this.data.contractedValueCurrencyId);
    }
    if (this.data.differentialCurrencyId) {
      this.loadDifferentialCurrency(this.data.differentialCurrencyId);
    }
    if (this.data.differentialUnitConverterId) {
      this.loadDifferentialUnit(this.data.differentialUnitConverterId);
    }
    if (this.data.hookUpFeeCurrencyId) {
      this.loadHookUpFeeCurrency(this.data.hookUpFeeCurrencyId);
    }
    if (this.data.hookUpFeeUnitConverterId) {
      this.loadHookUpFeeUnit(this.data.hookUpFeeUnitConverterId);
    }
    if (this.data.lessThan1000LtrCurrencyId) {
      this.loadLessThan1000LtrCurrency(this.data.lessThan1000LtrCurrencyId);
    }
    if (this.data.lessThan1000LtrUnitConverterId) {
      this.loadLessThan1000LtrUnit(this.data.lessThan1000LtrUnitConverterId);
    }
    if (this.data.noFuelCurrencyId) {
      this.loadNoFuelCurrency(this.data.noFuelCurrencyId);
    }
    if (this.data.noFuelUnitConverterId) {
      this.loadNoFuelUnit(this.data.noFuelUnitConverterId);
    }
    if (this.data.outOfHoursCurrencyId) {
      this.loadOutOfHoursCurrency(this.data.outOfHoursCurrencyId);
    }
    if (this.data.outOfHoursUnitConverterId) {
      this.loadOutOfHoursUnit(this.data.outOfHoursUnitConverterId);
    }
    if (this.data.safIndex) {
      this.loadSafIndexData(this.data.safIndex);
    }
    if (this.data.safIndexValueCurrencyId) {
      this.loadSafIndexValueCurrency(this.data.safIndexValueCurrencyId);
    }
    if (this.data.safIndexUnitConverterId) {
      this.loadSafIndexValueUnit(this.data.safIndexUnitConverterId);
    }
    if (this.data.sapSymbolId) {
      this.loadSapSymbol(this.data.sapSymbolId);
    }

    this.formatPaymentTerms(this.data.paymentTerms);
  }

  loadFuelSupplierContacts(fuelSupplierId: number): void {
    this.fuelSupplierService.getFuelSupplierById(fuelSupplierId).subscribe({
      next: (contacts) => {
        this.fuelSupplierContacts = contacts;
        this.accountManagerContacts = contacts.filter(
          (contact) => contact.contactType === 'ACCOUNT MANAGER',
        );
      },
      error: (err) => {
        console.error('Failed to load fuel supplier contacts:', err);
      },
    });
  }

  loadITPAgentContacts(contractId: number): void {
    this.airportContractListService
      .getITPAgentContacts({ airportContractId: contractId })
      .subscribe({
        next: (contacts) => {
          this.itpAgentContacts = contacts;
        },
        error: (err) => {
          console.error('Failed to load ITP agent contacts:', err);
        },
      });
  }

  loadFuelPriceIndexType(fuelPriceIndexTypeId: number): void {
    this.fuelPriceIndexTypeService
      .getFuelPriceIndexTypeById(fuelPriceIndexTypeId)
      .subscribe({
        next: (response: FuelPriceIndexType[]) => {
          const matchingType = response.find(
            (type) => type.id === fuelPriceIndexTypeId,
          );
          this.fuelPriceIndexTypeName = matchingType ? matchingType.name : '';
        },
        error: (err) => {
          console.error('Failed to load fuel price index type:', err);
          this.fuelPriceIndexTypeName = '';
        },
      });
  }

  loadFuelPriceIndex(fuelPriceIndexId: number): void {
    this.dictionaryFuelPriceIndexService.getById(fuelPriceIndexId).subscribe({
      next: (response: DictionaryFuelPriceIndexRecord[]) => {
        const matchingIndex = response.find(
          (index) => index.id === fuelPriceIndexId,
        );
        if (matchingIndex) {
          this.fuelPriceIndexName = matchingIndex.name;
          this.fuelPriceIndexSymbol = matchingIndex.symbol || '';
          this.fuelPriceIndexData = matchingIndex;
        } else {
          this.fuelPriceIndexName = '';
          this.fuelPriceIndexSymbol = '';
          this.fuelPriceIndexData = null;
        }
      },
      error: (err) => {
        console.error('Failed to load fuel price index:', err);
        this.fuelPriceIndexName = '';
        this.fuelPriceIndexSymbol = '';
        this.fuelPriceIndexData = null;
      },
    });
  }

  loadPapIndex(papIndexId: number): void {
    this.dictionaryPapIndexService.getAll().subscribe({
      next: (response: DictionaryPapIndexEntity[]) => {
        const matchingIndex = response.find((index) => index.id === papIndexId);
        if (matchingIndex) {
          this.papIndexName = matchingIndex.indexName;
          this.papIndexData = matchingIndex;
        } else {
          this.papIndexName = 'N/A';
          this.papIndexData = null;
        }
      },
      error: (err) => {
        console.error('Failed to load PAP index:', err);
        this.papIndexName = 'N/A';
        this.papIndexData = null;
      },
    });
  }

  loadAdditionalFees(airportContractId: number): void {
    this.airportContractListService
      .getAdditionalFees(airportContractId)
      .subscribe({
        next: (fees) => {
          this.additionalFees = fees;
          fees.forEach((fee) => {
            if (fee.fuelFeeId) {
              this.loadFuelPriceIndexForFee(fee.fuelFeeId);
            }
            if (fee.id && fee.feeUomCurrencyId) {
              this.loadAdditionalFeeCurrency(fee.id, fee.feeUomCurrencyId);
            }
            if (fee.id && fee.feeUomUnitConverterId) {
              this.loadAdditionalFeeUnit(fee.id, fee.feeUomUnitConverterId);
            }
          });
        },
        error: (err) => {
          console.error('Failed to load additional fees:', err);
        },
      });
  }

  loadFuelPriceIndexForFee(fuelFeeId: number): void {
    this.dictionaryFuelPriceIndexService.getById(fuelFeeId).subscribe({
      next: (response: DictionaryFuelPriceIndexRecord[]) => {
        if (response && response.length > 0) {
          this.fuelPriceIndexMap.set(fuelFeeId, response[0]);
        }
      },
      error: (err: any) => {
        console.error('Failed to load fuel price index for fee:', err);
      },
    });
  }

  getFeeUom(fuelFeeId?: number): string {
    if (!fuelFeeId) return '';
    const fuelPriceIndex = this.fuelPriceIndexMap.get(fuelFeeId);
    return fuelPriceIndex?.uom1 || '';
  }

  loadAdditionalFeeCurrency(feeId: number, currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        if (matching) {
          this.additionalFeeCurrencyMap.set(feeId, matching.Code);
        }
      },
      error: (err: any) => {
        console.error('Failed to load additional fee currency:', err);
      },
    });
  }

  loadAdditionalFeeUnit(feeId: number, unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        if (matching) {
          this.additionalFeeUnitMap.set(feeId, matching.Unit);
        }
      },
      error: (err: any) => {
        console.error('Failed to load additional fee unit:', err);
      },
    });
  }

  getAdditionalFeeCurrency(feeId?: number): string {
    if (!feeId) return '';
    return this.additionalFeeCurrencyMap.get(feeId) || '';
  }

  getAdditionalFeeUnit(feeId?: number): string {
    if (!feeId) return '';
    return this.additionalFeeUnitMap.get(feeId) || '';
  }

  getAdditionalFeeUom(feeId?: number): string {
    if (!feeId) return '';
    const currency = this.getAdditionalFeeCurrency(feeId);
    const unit = this.getAdditionalFeeUnit(feeId);
    return currency && unit ? `${currency}/${unit}` : currency || unit || '';
  }

  getIndexValue(): number {
    if (this.papIndexData) {
      return this.papIndexData.indexValue || 0;
    }

    if (!this.fuelPriceIndexData) return 0;

    const indexTypeName = this.fuelPriceIndexTypeName.toLowerCase();

    if (indexTypeName.includes('daily')) {
      return this.fuelPriceIndexData.indexValueDaily || 0;
    } else if (indexTypeName.includes('weekly monday')) {
      return this.fuelPriceIndexData.indexValueWeeklyMonday || 0;
    } else if (indexTypeName.includes('weekly tuesday')) {
      return this.fuelPriceIndexData.indexValueWeeklyTuesday || 0;
    } else if (
      indexTypeName.includes('biweekly') ||
      indexTypeName.includes('bi-weekly')
    ) {
      return this.fuelPriceIndexData.indexValueWeeklyBiweekly || 0;
    } else if (indexTypeName.includes('monthly')) {
      return this.fuelPriceIndexData.indexValueMonthly || 0;
    }

    return this.fuelPriceIndexData.indexValueDaily || 0;
  }

  getIndexValueUom(): string {
    if (this.papIndexData) {
      return this.papIndexData.uoM || '';
    }

    if (!this.fuelPriceIndexData) return '';
    const uom2 = this.fuelPriceIndexData.uom2 || '';
    const uom1 = this.fuelPriceIndexData.uom1 || '';
    return uom2 && uom1 ? `${uom2}/${uom1}` : uom2 || uom1 || '';
  }

  getIndexMultiply(): number | string {
    return this.fuelPriceIndexData?.multiply || '';
  }

  loadContractedAmountUnit(unitConverterId: number): void {
    this.dictionaryUnitConverterService.getById(unitConverterId).subscribe({
      next: (response: any[]) => {
        const matchingUnit = response.find(
          (unit) => unit.Id === unitConverterId,
        );
        this.contractedAmountUnit = matchingUnit ? matchingUnit.Unit : 'T';
      },
      error: (err: any) => {
        console.error('Failed to load contracted amount unit:', err);
        this.contractedAmountUnit = 'T';
      },
    });
  }

  loadContractedValueCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matchingCurrency = response.find(
          (currency) => currency.Id === currencyId,
        );
        this.contractedValueCurrency = matchingCurrency
          ? matchingCurrency.Code
          : 'USD';
      },
      error: (err: any) => {
        console.error('Failed to load contracted value currency:', err);
        this.contractedValueCurrency = 'USD';
      },
    });
  }

  formatPaymentTerms(paymentTerms: number | null): void {
    if (paymentTerms || paymentTerms == 0) {
      this.paymentTerms = paymentTerms.toString().padStart(4, '0');
    } else {
      this.paymentTerms = ' ';
    }
  }

  loadIndexValueCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.indexValueCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load index value currency:', err);
      },
    });
  }

  loadIndexValueUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.indexValueUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load index value unit:', err);
      },
    });
  }

  loadDifferentialCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.differentialCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load differential currency:', err);
      },
    });
  }

  loadDifferentialUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.differentialUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load differential unit:', err);
      },
    });
  }

  loadHookUpFeeCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.hookUpFeeCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load hook up fee currency:', err);
      },
    });
  }

  loadHookUpFeeUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.hookUpFeeUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load hook up fee unit:', err);
      },
    });
  }

  loadLessThan1000LtrCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.lessThan1000LtrCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load lessThan1000Ltr currency:', err);
      },
    });
  }

  loadLessThan1000LtrUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.lessThan1000LtrUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load lessThan1000Ltr unit:', err);
      },
    });
  }

  loadNoFuelCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.noFuelCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load no fuel currency:', err);
      },
    });
  }

  loadNoFuelUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.noFuelUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load no fuel unit:', err);
      },
    });
  }

  loadOutOfHoursCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.outOfHoursCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load out of hours currency:', err);
      },
    });
  }

  loadOutOfHoursUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.outOfHoursUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load out of hours unit:', err);
      },
    });
  }

  loadSafIndexData(safIndexId: string): void {
    this.safIndexName = safIndexId;
    this.safIndexValue = this.data.safIndexValue || 0;
  }

  loadSafIndexValueCurrency(currencyId: number): void {
    this.dictionaryCurrencyService.getById(currencyId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((c) => c.Id === currencyId);
        this.safIndexValueCurrency = matching ? matching.Code : '';
      },
      error: (err: any) => {
        console.error('Failed to load SAF index value currency:', err);
      },
    });
  }

  loadSafIndexValueUnit(unitId: number): void {
    this.dictionaryUnitConverterService.getById(unitId).subscribe({
      next: (response: any[]) => {
        const matching = response.find((u) => u.Id === unitId);
        this.safIndexValueUnit = matching ? matching.Unit : '';
      },
      error: (err: any) => {
        console.error('Failed to load SAF index value unit:', err);
      },
    });
  }

  loadSapSymbol(sapSymbolId: number): void {
    this.dictionarySapSymbolsService.getById(sapSymbolId).subscribe({
      next: (response: any[]) => {
        if (response && response.length > 0) {
          this.sapSymbolValue = response[0].symbol || '';
        }
      },
      error: (err: any) => {
        console.error('Failed to load SAP symbol:', err);
      },
    });
  }

  getAttachments(airportContractListId: number) {
    this.airportContractListAttachmentService
      .getAttachments(airportContractListId)
      .subscribe((data) => {
        this.attachments = data.sort((a, b) => a.originalFileName.localeCompare(b.originalFileName));
      });
  }

  downloadAttachment(attachmentId: number) {
    this.downloadingFile = true;
    this.airportContractListAttachmentService
      .getAttachmentDownloadUrl(attachmentId)
      .subscribe({
        next: (response) => {
          window.open(response.url, '_blank');
          this.downloadingFile = false;
        },
        error: (err) => {
          console.error('Failed to download attachment:', err);
          this.downloadingFile = false;
        },
      });
  }

  removeAttachment(attachment: AirportContractListAttachmentRecord) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Attention',
        message: `Are you sure you want to delete this record?`,
        buttons: {
          cancel: 'Cancel',
          confirm: 'Delete',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        const rowIndex = this.attachments.indexOf(attachment);
        const attachmentsToRemove: number[] = [ attachment.id ];
        this.airportContractListAttachmentService
          .deleteAttachments(attachmentsToRemove)
          .subscribe({
            next: () => {
              this.getAttachments(this.data.id!);
            },
            error: (err) => {
              console.error('Failed to load attachments:', err);
            },
          });
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}